'use client'

import { Button } from '@wartek-id/button'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogOverlay,
} from '@wartek-id/dialog'

import { WILAYAH_NASIONAL } from '@/apis/data/statistik/wilayah'

import { SelectionItem } from './SelectionItem'
import { WilayahSelectionProps } from './types'
import { useWilayahSelection } from './useWilayahSelection'
import { WilayahSearchText } from './WilayahSearchText'

export function WilayahSelectionDialog({
  data,
  show,
  onClose,
  onSelect,
}: WilayahSelectionProps) {
  const {
    handleChangeKeyword,
    handleSelectProvince,
    handleSelectCity,
    handleSubmit,
    handleClose,

    selectedText,
    selectedCity,
    selectedProvince,
    cities,
    provincies,
  } = useWilayahSelection({
    data,
    show,
    onClose,
    onSelect,
  })

  return (
    <Dialog onClose={handleClose} isOpen={show} size="md" autoFocus={false}>
      <DialogOverlay />
      <DialogContent>
        <div className="border-b shadow-sm">
          <WilayahSearchText onChange={handleChangeKeyword} />
        </div>

        <div className="flex max-h-[500px] w-full overflow-hidden pb-4">
          <div
            className="flex max-h-[400px] min-h-[200px] flex-1 flex-col gap-1 overflow-auto border-r p-2"
            data-testid="box-national"
          >
            <SelectionItem
              text="Indonesia"
              testId={WILAYAH_NASIONAL.id}
              selected
              onClick={() => {
                handleSelectProvince(null)
              }}
            />
          </div>
          <div
            className="flex max-h-[400px] min-h-[200px] flex-1 flex-col gap-1 overflow-auto border-r p-2"
            data-testid="box-province"
          >
            {provincies &&
              provincies.length > 0 &&
              provincies?.map((item) => {
                return (
                  <SelectionItem
                    key={item.id}
                    testId={item.id}
                    text={item.name}
                    selected={
                      selectedProvince !== null &&
                      // @ts-ignore
                      selectedProvince?.id === item.id
                    }
                    onClick={() => {
                      handleSelectProvince(item)
                    }}
                  />
                )
              })}
          </div>
          <div
            className="flex max-h-[400px] min-h-[200px] flex-1 flex-col gap-1 overflow-auto p-2"
            data-testid="box-city"
          >
            {cities &&
              cities.length > 0 &&
              cities.map((item) => {
                return (
                  <SelectionItem
                    testId={item.id}
                    key={item.id}
                    text={item.name}
                    tail={true}
                    selected={
                      selectedCity !== null &&
                      // @ts-ignore
                      selectedCity?.id === item.id
                    }
                    onClick={() => {
                      handleSelectCity(item)
                    }}
                  />
                )
              })}
          </div>
        </div>
        <DialogFooter>
          <Button
            fullWidth
            onClick={handleSubmit}
            data-testid="btn-select-wilayah"
          >
            Pilih Wilayah ({selectedText})
          </Button>
        </DialogFooter>
        <DialogCloseButton data-testid="btn-close-dialog" />
      </DialogContent>
    </Dialog>
  )
}
